export const defaultLabels = {};
export const defaultConfig = {};
